<div class="border-card border-0 px-4 py-1 scroll-container" ref="reolve_request">
  <NavigationBackButton />
   <div class="card-header card-header-primary shadow-2 rounded-lg mt-3">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <p class="p-1 fw-bold text-white mb-0">Request Overview</p>
        </div>
      </div>
    </div>

    <div class="card-body bg-white mt-2 rounded-lg shadow-sm">
      <div class=" p-4 rounded">
        <p class="fw-bold mb-3 text-x">Request</p>
        <hr/>
        <!-- Message Card -->
        <div class="card mb-3 border-0 shadow-sm hover-card gray-background shadow">
          <div class="card-body px-3 py-2  shadow-sm">
            <p class="text-xxs mt-3">{{ request_note }}</p>
            <div class="text-end text-xxs text-muted">{{ date_requested }}</div>
          </div>
        </div>

        <div>
          <p class="text-xs fw-bold mb-2">Documents</p>
          <ul class="text-secondary text-xxs small mb-3 ps-3 ms-3">
            <li v-for="(doc, index) in fields" :key="index">{{ doc.label }}</li>
          </ul>
        </div>

        <hr class="my-4 mb-5 ">
        <p class="fw-bold mb-3 text-x">Response</p>
        <div class="text-xs">
          <div class="fw-bold mb-2">Documents</div>

          <!-- Document Header -->
          <div class="d-flex border rounded-top p-2 card-bg text-white shadow">
            <div class="col-1">No</div>
            <div class="col-4">Document Name</div>
            <div class="col-3">Date Uploaded</div>
            <div class="col-2">Review Status</div>
            <div class="col-2">Action</div>
          </div>


          <!-- Document Rows -->
          <div v-for="(doc, index) in request_response" :key="index"
            class="document-row d-flex border-start border-end border-bottom p-2 align-items-center shadow"
            :class="{ 'rounded-bottom': index === request_response.length - 1 }">

            <div class="col-1">{{ index + 1 }}</div>

            <div class="col-4 text-truncate">
              {{ doc.name }}
            </div>

            <div class="col-3">{{ doc.date_created }}</div>

            <div class="col-2">
              <span class="badge px-2 py-1" :class="{
                'bg-success text-white': doc.review_status === 'Approved',
                'bg-danger text-white': doc.review_status === 'Rejected',
                'bg-secondary text-white': doc.review_status === 'Pending Review'
              }">
                {{ doc.review_status }}
              </span>
            </div>

            <div class="col-2 d-flex flex-wrap gap-1">
              <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                @click="open_document(doc)">
                View
              </button>

              <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                :disabled="doc.review_status !== 'Pending Review'"
                @click="approve_response(doc)">
                Approve
              </button>

              <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
                :disabled="doc.review_status !== 'Pending Review'"
                @click="reject_response(doc)">
                Reject
              </button>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <p class="text-xs fw-bold mb-1">Notes</p>
          <textarea class="form-control bg-white text-xxs pt-2 resize-vertical shadow" rows="4"></textarea>
        </div>
        <div class="d-flex justify-content-end mt-auto gap-2">
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs shadow mt-3"
            @click="resolve_request">Resolve</button>
          <button type="submit" class="btn btn-primary-dark btn-sm text-xxs shadow mt-3">Respond</button>
        </div>
      </div>
    </div>
</div>

    


<div v-if="preview_modal" @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_file.presigned_url" @close="close_the_file_preview"
    :key="selected_file.presigned_url" />
</div>